import { render, staticRenderFns } from "./BReadOnlyTextField.vue?vue&type=template&id=1e6f8a92&"
import script from "./BReadOnlyTextField.vue?vue&type=script&lang=js&"
export * from "./BReadOnlyTextField.vue?vue&type=script&lang=js&"
import style0 from "./BReadOnlyTextField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports